export function formatProductQuantity(value) {
	var quantity = Number(value);

	if (isNaN(quantity) || quantity < 1) {
		return 1;
	}

	return Math.floor(quantity);
}
